import type { TInterviewer } from '@shared/types/interviewer';
import { object, string, mixed } from 'yup';

export const MAX_INTERVIEWER_IMAGE_SIZE = 1000000; // 1 mb

export const interviewerFormNames = {
  interviewerName: 'interviewerName',
  email: 'email',
  avatar: 'avatar',
  jobTitle: 'jobTitle',
  companyName: 'companyName',
} as const;

export const createInterviewerFormInitialValue = (
  interviewer?: TInterviewer,
  hostCompany?: string
) => {
  return {
    interviewerName: '',
    email: '',
    avatar: undefined,
    jobTitle: '',
    companyName: hostCompany ?? '',
    ...createInitialValueFromExistingInterviewer(interviewer),
  };
};

const createInitialValueFromExistingInterviewer = (
  interviewer?: TInterviewer
) => {
  if (!interviewer) return {};

  return {
    interviewerName: interviewer.name,
    email: interviewer.email,
    avatar: interviewer.avatar,
    jobTitle: interviewer.job_title,
    companyName: interviewer.company_name,
  };
};

export const interviewerFormSchema = object().shape({
  interviewerName: string().required('Please enter interviewer name'),
  email: string().email().required('Please enter email'),
  avatar: mixed().nullable(),
  jobTitle: string().required('Please enter job title'),
  companyName: string().required('Please enter company name'),
});

export type TInterviewerValues = ReturnType<
  typeof createInterviewerFormInitialValue
>;
